// src/routes/users/EditUser.jsx
import React, { useState, useEffect, useContext } from 'react'
import "react-toastify/dist/ReactToastify.css";

import { toast } from "react-toastify";
import { useNavigate, useParams } from 'react-router-dom';

import { AuthService } from '../../api/AuthService';
import { AuthContext } from "../../components/authcontext/AuthContext";

const EditUser = () => {
  const navigate = useNavigate();

  const { id } = useParams()
  const [loading, setLoading] = useState(false);

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [country, setCountry] = useState('');
  const [monthlyCases, setMonthlyCases] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [profile, setProfile] = useState(null);
  const [roles, setRoles] = useState([]);
  const [permissions, setpermissions] = useState([]);
  const [role, setRole] = useState('');
  const [clientLoginUri, setClientLoginUri] = useState('');
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [isHours, setIsHours] = useState('');

  const handleProfile = (event) => {
    const file = event.target.files[0];
    setProfile(file);
  }

  const { currentUser } = useContext(AuthContext);
  const userType = currentUser?.role_name;

  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    const checkboxId = parseInt(id, 10); // Convert id to a number

    setSelectedCheckboxes((prevSelected) => {
      if (checked) {
        // Add the checkbox ID to the array if checked
        return [...prevSelected, checkboxId];
      } else {
        // Remove the checkbox ID from the array if unchecked
        return prevSelected.filter((prevId) => prevId !== checkboxId);
      }
    });
  };

  const getUserDetailFunction = async (idd) => {

    try {
      const result = await AuthService.getUserDetail(idd);

      if (result?.data?.status === 200)
      {
        const userData = result?.data?.data;

        setFirstName(userData?.first_name);
        setLastName(userData?.last_name);
        setEmail(userData?.email);
        setUserName(userData?.username);
        setCountry(userData?.country_name);
        setMonthlyCases(userData?.monthly_target_cases);
        setMobileNumber(userData?.mobile_number);
        setIsHours(userData?.is_8_hours_enabled);
        setRole(userData?.roles[0]?.id);
        setClientLoginUri(userData?.client_login_uri);
        
        userData?.roles[0]?.permissions?.forEach((per) => {
          setSelectedCheckboxes((prevSelected) => {
            const newSelected = new Set(prevSelected); // Convert array to Set
            newSelected.add(parseInt(per.id)); // Add new ID
            return Array.from(newSelected); // Convert Set back to array
          });
        });

      }
      else {
        if (result?.data?.message === "Unauthenticated.") {
          navigate('/login');
        }
        toast.error(result?.data?.message, {
          autoClose: 2000,
          draggable: true,
          pauseOnHover: true,
        });
      }
    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    }
    finally {
      setLoading(false)
    }
  };

  const getAllRoles = async () => {
    try {
      const result = await AuthService.getRoles();

      if (result?.data?.status === 200) {
        setRoles(result?.data?.data);
      }
    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        draggable: true,
        pauseOnHover: true,
      });
    }
    finally {
      setLoading(false)
    }
  };

  const getAllPermissions = async () => {
    try {
      const result = await AuthService.getPermissions();

      if (result?.data?.status === 200) {
        setpermissions(result?.data?.data);
      }
    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        pauseOnHover: true,
        draggable: true,
      });
    }
    finally {
      setLoading(false)
    }
  };

  const updateUserFunction = async () => {

    try {
      const formData = new FormData()
      if (!firstName) {
        toast.error("please enter first name", {
          autoClose: 2000,
          draggable: true,
          pauseOnHover: true,
        });
      }

      else if (!lastName) {
        toast.error("please enter last name", {
          autoClose: 2000,
          pauseOnHover: true,
          draggable: true,
        });
      }

      else {
        setLoading(true)
        if (firstName) {
          formData.append('first_name', firstName)
        }
        
        if (lastName) {
          formData.append('last_name', lastName)
        }
        
        if (userName) {
          formData.append('username', userName)
        }
        
        if (email) {
          formData.append('email', email)
        }
        
        if (country) {
          formData.append('country_name', country)
        }
        
        if (monthlyCases) {
          formData.append('monthly_target_cases', monthlyCases)
        }
        
        if (mobileNumber) {
          formData.append('mobile_number', mobileNumber)
        }
        
        if (profile) {
          formData.append('profile_pic', profile)
        }
        
        if (password) {
          formData.append('password', password)
        }
        
        if (confirmPassword) {
          formData.append('password_confirmation', confirmPassword)
        }
        
        if (role) {
          formData.append('role_id', role)
        }
                
        if (clientLoginUri) {
          formData.append('client_login_uri', clientLoginUri)
        }

        if (isHours) {
          formData.append('is_8_hours_enabled', isHours)
        }

        if (selectedCheckboxes) {
          selectedCheckboxes?.map((id, index) => {
            formData.append(`permissions[${index}]`, id)
          })
        }

        const result = await AuthService.updateUser(id, formData);

        if (result?.data?.status === 200) {
          toast.success(result?.data?.message, {
            autoClose: 1000,
            pauseOnHover: true,
            draggable: true,

          });
        }
        else {
          toast.error(result?.data?.message, {
            autoClose: 2000,
            pauseOnHover: true,
            draggable: true,
          });
        }
      }
    } catch (error) {
      toast.error(error?.result?.data?.errors[0], {
        autoClose: 2000,
        draggable: true,
        pauseOnHover: true,
      });
    }
    finally {
      setLoading(false)
    }
  };
  
  useEffect(() => {
    getAllRoles()
    getAllPermissions()
    getUserDetailFunction(id)
  }, []);

  return (
    <div className='form-wrapper'>

      {loading && <div className="loader-parent"><div className="_loader"></div></div>}

      <div className="title">Update user</div>

      {userType === 'super_admin' && <div className="allow-times">
        <div className="inner">
          <div className="for-group">
            <label htmlFor="">Express setup delivery allowed for this user? <span>*</span></label>
            <select name="" id="" className='input' value={isHours} onChange={(e) => setIsHours(e.target.value)}>
              <option value="">Select below</option>
              <option value="1">Yes</option>
              <option value="0">No</option>
            </select>
          </div>
        </div>
      </div>}

      <div className="row">
        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">First Name <span>*</span></label>
          <input type="text" className='input' value={firstName} onChange={(e) => setFirstName(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Last Name <span>*</span></label>
          <input type="text" className='input' value={lastName} onChange={(e) => setLastName(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">User Id <span>*</span></label>
          <input type="text" className='input' value={userName} onChange={(e) => setUserName(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Email</label>
          <input type="text" className='input' value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Monthly target (cases) <span>*</span></label>
          <input type="text" className='input' value={monthlyCases} onChange={(e) => setMonthlyCases(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Country Name <span>*</span></label>
          <input type="text" className='input' value={country} onChange={(e) => setCountry(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Mobile Number</label>
          <input type="text" className='input' value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">Profile Image</label>
          <input type="file" className='input' onChange={handleProfile} />
        </div>

        <div className="col-12 col-md-6 mb-4">
          <label htmlFor="">User Role</label>
          <select className="input" value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="">Please select role</option>
            {roles?.map((rol) => <option value={rol?.id} >{rol?.name}</option>)}
          </select>
        </div>

        { // Set user client_login_uri only if its role(2) is client
          (role === 2 || role === '2') &&
          <div className="col-12 col-md-6 mb-4">
            <label htmlFor="">Client Login Uri</label>
            <input type="text" className='input' value={clientLoginUri} onChange={(e) => setClientLoginUri(e.target.value)} />
          </div>
        }
      </div>

      <div className="title">Permissions</div>

      <div className="permissions-wrapper">
        {permissions?.map((per) => <div className="checkboxx" key={per?.id}>
          <input
            type="checkbox"
            id={parseInt(per.id)}
            onChange={handleCheckboxChange}
            checked={selectedCheckboxes?.includes(parseInt(per.id))}
          />
          <label htmlFor={parseInt(per.id)}>{per.name}</label>
        </div>)}
      </div>

      <div className="d-flex justify-content-center my-3">
        <button className="button" onClick={updateUserFunction}>Update user </button>
      </div>

    </div>
  )
}

export default EditUser